import { useGetSandboxes } from '@/api/getSandboxes';
import { splitSandboxes } from '@/models/sandbox';

export const useCurrentSandbox = (gameCode: string, sandboxCode: string) => {
  const { data, isLoading } = useGetSandboxes({ game_code: gameCode });
  return {
    ...splitSandboxes(data?.sandboxes ?? [], sandboxCode),
    isLoading,
  };
};
